exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.introduce[data-v-e02805a8] {\n  text-align: center;\n  color: #000000;\n  padding-bottom: 100px;\n}\n.introduce .title[data-v-e02805a8] {\n    font-size: 20px;\n    margin: 20px auto 30px auto;\n}\n.introduce .des[data-v-e02805a8] {\n    padding: 10px 5%;\n    font-size: 14px;\n    text-align: left;\n}\n.introduce .code[data-v-e02805a8] {\n    display: block;\n    margin: 20px auto 10px auto;\n    width: 120px;\n}\n", ""]);

// exports
